<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-descriptions title="" labelClassName='labelClassName' :column="1" border>
				<el-descriptions-item label="课程名称">{{detailObject.name}}</el-descriptions-item>
				<el-descriptions-item label="一级分类">{{detailObject.course_cate_name}}</el-descriptions-item>
				<el-descriptions-item label="二级分类">{{detailObject.sub_course_cate_name}}</el-descriptions-item>
				<el-descriptions-item label="课程权重">{{detailObject.weight}}</el-descriptions-item>
				<el-descriptions-item label="课程章节数">{{chapter.length}}</el-descriptions-item>
				<el-descriptions-item label="课程封面">
					<img :src="detailObject.img" style="width: 120px;height: 120px;border-radius: 5px;" />
				</el-descriptions-item>
				<el-descriptions-item label="课程介绍">
					<div v-html="detailObject.desc"></div>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>章节信息</h4>
			</div>

			<el-collapse>
				<el-collapse-item v-model='activeName' v-for="(item,index) in chapter" :name="index+1">
					<template slot="title">
						<div class="flex flex-b" style="width: 100%;">
							<div>第{{(index+1)}}章</div>
						</div>
					</template>
					<el-descriptions style="margin-top: 20px;" title="" :column="1" border>
						<el-descriptions-item label="章节名称">{{item.name}}</el-descriptions-item>
						<el-descriptions-item label="章节描述">{{item.desc}}</el-descriptions-item>
						<el-descriptions-item label="章节售价">{{item.score}}</el-descriptions-item>
						<el-descriptions-item
							label="章节类型">{{item.type==1?'视频':item.type==2?'音频':item.type==3?'PDF':item.type==4?'PPT':''}}</el-descriptions-item>
						<el-descriptions-item label="是否支持试看">{{item.is_see==1?'是':'否'}}</el-descriptions-item>
						<el-descriptions-item label="视频文件" v-if="item.type==1 || item.type == 2">
							<video controls="controls" :src="getUrl(item.file.url)" style="width: 600px;"></video>
							<div class="pointer" style="margin-top: 10px;color: #5ba3fc;" v-if="item.type==1"
								@click="editAdminClick(item)">查看章节要点</div>
						</el-descriptions-item>
						<el-descriptions-item label="课程文件" v-if="item.type==3||item.type==4">
							<a :href="getUrl(item.file.url)" target="_blank">{{getUrl(item.file.url)}}</a>
						</el-descriptions-item>
						<el-descriptions-item label="试看文件" v-if="(item.type==3||item.type==4) && item.is_see==1">
							<a :href="getUrl(item.fee_file.url)" target="_blank">{{getUrl(item.fee_file.url)}}</a>
						</el-descriptions-item>
					</el-descriptions>
				</el-collapse-item>
			</el-collapse>
		</el-card>

		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>课程评论</h4>
			</div>
			<el-table :data="tableData1" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" style="width: 100%">
				<el-table-column prop="name" label="用户昵称" align="center">
				</el-table-column>
				<el-table-column prop="phone" label="绑定手机号" align="center">
				</el-table-column>
				<el-table-column prop="order_id" label="订单编号" align="center">
				</el-table-column>
				<el-table-column prop="content" label="评论内容" align="center">
				</el-table-column>
				<el-table-column prop="address" label="评论状态" align="center">
					<template slot-scope="scope">
						{{scope.row.status==1?'待审核':scope.row.status==2?'通过':'不通过'}}
					</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap" v-if="scope.row.status == 1">
							<span class="pointer" style="color: #ff0000;"
								@click="UserDisableClickCom(scope.row,2)">通过</span>
							<span class="pointer" style="margin-left: 10px;"
								@click="UserDisableClick(scope.row,3)">驳回</span>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>
		</el-card>


		<el-dialog title="拒绝" :visible.sync="dialogFormVisible">
			<el-form>
				<el-form-item label="拒绝原因" label-width="180">
					<el-input type='textarea' :rows='4' v-model="reason"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogFormVisibleClick">确 定</el-button>
			</div>
		</el-dialog>


		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 200px;" plain @click="goBack">返回</el-button>
		</el-card>

		<CoursePointsDetailDialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
			@confirm="confirmDialog">
		</CoursePointsDetailDialog>


	</div>
</template>

<script>
	import CoursePointsDetailDialog from "./CoursePointsDetailDialog.vue"
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getCourseDetail,
		getDoubao,
		getAiApplicationHistoryList,
		getCourseOrderEvaluate,
		putCourseOrderEvaluate
	} from "@/api/course"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				dialogFormVisible: false,
				editdialogVisible: false,
				selectForm: {},
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 10,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				hisLists: [],
				tableData1: [],
				chapter: [],
				reason: '',
				currentItem: ''
			};
		},
		components: {
			CommonPagination,
			CoursePointsDetailDialog
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			if (uuid) {
				this.getCourseDetail(uuid);
				this.getDoubao(uuid)
			}
		},
		methods: {
			async UserDisableClick(item) {
				this.currentItem = item
				this.dialogFormVisible = true
			},
			async dialogFormVisibleClick() {
				if (!this.reason) {
					return this.$message.error('请填写原因')
				}
				const {
					status,
					data
				} = await putCourseOrderEvaluate({
					status: 3,
					reason: this.reason,
					uuid: this.currentItem.uuid
				});
				if (status !== 200) return;
				this.$message.success('审核成功')
				this.dialogFormVisible = false
				this.getDoubao(this.user_uuid)
			},
			async UserDisableClickCom(item, sta) {
				const {
					status,
					data
				} = await putCourseOrderEvaluate({
					status: sta,
					reason: this.reason,
					uuid: item.uuid
				});
				if (status !== 200) return;
				this.$message.success('审核成功')
				this.getDoubao(this.user_uuid)
			},
			getUrl(url) {
				if (url && url.indexOf('http') == -1) {
					return imgDomain + url
				} else {
					return url
				}
			},
			closeDialog(row) {
				this.editdialogVisible = false;
			},
			confirmDialog(row, index) {
				this.editdialogVisible = false;
			},
			editAdminClick(row, index) {
				this.editdialogVisible = true;
				this.selectForm = row;
				this.currentChapterIndexProp = index
			},
			handlePageChange(page) {
				this.page_index = page
				this.getDoubao()
			},
			handleSizeChange(e) {
				this.page_size = e
				this.getDoubao()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getDoubao()
				}
			},
			async getDoubao() {
				let postData = {
					page_size: this.page_size,
					page_index: this.page_index,
					course_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getCourseOrderEvaluate(postData);
				if (status !== 200) return;
				this.tableData1 = data.result.data;
				this.total = data.result.total;
			},
			async getAiApplicationHistoryList() {
				let postData = {
					page_size: this.page_size1,
					page_index: this.page_index1,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getAiApplicationHistoryList(postData);
				if (status !== 200) return;
				this.hisLists = data.result.data;
				this.total1 = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async getCourseDetail(uuid) {
				const {
					data,
					status
				} = await getCourseDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.detailObject = data.result;
					this.chapter = this.detailObject.chapter
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}

	::v-deep .el-descriptions-item__label {
		width: 15% !important;
	}

	::v-deep .el-descriptions-item__cell {
		color: #000;
	}
</style>